/* eslint-disable import/prefer-default-export */
// https://stackoverflow.com/questions/35464067/flexbox-not-working-on-button-or-fieldset-elements
export const INLINE_ELEMENTS_FLEX_FIX = {
  button: true,
  fieldset: true,
  legend: true,
}
